/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable no-undef */
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import { getParsedPriceBreakup } from "../post-inspection-diy-container/selector";
import { parseChallanDetails } from "../post-inspection-diy/selector";
import { pickupDocuments } from "../post-inspection-diy/actions";

const getSellerReceipt = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.sellerReceipt(token)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const geFinalPayments = (token) => {
    return new Promise((resolve, reject) => {
        carConsumerService.geFinalPayments(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

// eslint-disable-next-line no-unused-vars
const getCarHandOverDetails = (postInspectionDiy)  => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                inspectionResponse = {},
                priceBreakup: priceBreakupDetails
            } = postInspectionDiy || {};
            const {
                token,
                showServiceCharge = true,
                priceDo: auctionResponse,
                isDeliveryApproved = false,
                appointmentId
            } = inspectionResponse || {};
            const { offeredPrice } = auctionResponse || {};
            const { deductions = {} } = priceBreakupDetails || {};
            const { challanDetails = {} } = deductions || {};

            let sellerReceiptPromise = Promise.resolve({});
            let finalPaymentsPromise = Promise.resolve({});

            dispatch(pickupDocuments(appointmentId));
            if (isDeliveryApproved) {
                sellerReceiptPromise = getSellerReceipt(token);
                finalPaymentsPromise = geFinalPayments(token);
            }

            const [
                finalPayments,
                sellerReceipt
            ] = await Promise.all([
                finalPaymentsPromise,
                sellerReceiptPromise
            ]);

            const { payments = []} = finalPayments;
            const challanData = parseChallanDetails(challanDetails);
            resolve({
                ...postInspectionDiy,
                priceBreakup: {
                    ...priceBreakupDetails,
                    ...getParsedPriceBreakup({priceBreakup: sellerReceipt.priceBreakup, showServiceCharge, challanDetails: challanData, offeredPrice}),
                    pendingPayments: payments
                },
                sellerReceipt
            });

        } catch (e) {
            reject(e);
        }
    });
};

export {
    getCarHandOverDetails
};
